import { Table } from "design-system/components/blocks/table/table";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { TableEntry } from "frontend/contentful/schema/blocks";
import { createTableProps } from "./table.props";

export interface TableOptions {
  headerAbove?: boolean;
}

export const ContentfulTable = createContentfulComponent<
  TableEntry,
  TableOptions
>(({ entry, options }) => {
  const props = createTableProps(entry, options);

  return <Table {...props} />;
});
